import type { FC } from "react";

type ImageViewerProps = {
  fileId: string;
};

export const ImageViewer: FC<ImageViewerProps> = ({ fileId }) => {
  return (
    <div className="flex items-center justify-center h-full w-full p-2 overflow-auto bg-zinc-100 dark:bg-zinc-900">
      <img
        src={`/api/file/${fileId}`}
        className="max-h-full max-w-full object-contain"
        alt=""
      />
    </div>
  );
};
